export const getGrandChartWindowWidth = (modulesCount: number) => {
	const logoWidth = 170;
	const moduleWidth = 220;
	const gap = 10;
	const padding = 10;
	const minWindowWidth = 870;
	const contentWidth = logoWidth + gap + modulesCount * moduleWidth + Math.max(modulesCount - 1, 0) * gap + padding;
	return `${Math.max(contentWidth, minWindowWidth)}px`;
};

export const getGrandChartWindowHeight = (coursesCount: number) => {
	const headerHeight = 86;
	const courseHeight = 250;
	const gap = 20;
	const padding = 10;
	const minHeight = 360;
	const contentHeight =
		headerHeight + gap + coursesCount * courseHeight + Math.max(coursesCount - 1, 0) * gap + padding;
	return `${Math.max(contentHeight, minHeight)}px`;
};

export const removeGroupLessonRouteTail = (pathname: string): string => {
	return pathname.replace(/\/course\/[^/]+\/module\/[^/]+\/group\/[^/]+\/?$/, "");
};

export const getGrandChartRoute = (
	pathname: string,
	grandChartId: number | string,
	grandChartCourseId: number | string = "",
	grandChartModuleId: number | string = "",
	grandChartGroupLessonId: number | string = "",
): string => {
	const basePath = pathname.replace(/\/grand-chart\/[^/]+.*$/, "");

	if (!grandChartCourseId && !grandChartModuleId && !grandChartGroupLessonId) {
		return `${basePath}/grand-chart/${grandChartId}`;
	}

	return `${basePath}/grand-chart/${grandChartId}/course/${grandChartCourseId}/module/${grandChartModuleId}/group/${grandChartGroupLessonId}`;
};

export const getGroupLessonRoute = (
	pathname: string,
	params: {
		grandChartId: number | string;
		courseId: number | string;
		moduleId: number | string;
		groupId: number | string;
	},
): string => {
	const grandChartPath = getGrandChartRoute(
		pathname,
		params.grandChartId,
		params.courseId,
		params.moduleId,
		params.groupId,
	);
	return `${grandChartPath}`;
};

export const removeGrandChartRoute = (pathname: string) => {
	return pathname.replace(/\/grand-chart\/[^/]+(\/course\/[^/]+\/module\/[^/]+\/group\/[^/]+)?\/?$/, "");
};
